import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { GetDrawDownRepaymentScheduleCreditFacilityResponse } from '@iwoca/lapi-client/edge';
import { Text } from '@iwoca/orion';
import {
    Table,
    TableHeader,
    TableCell,
    TableBody,
    TableHead,
    TableRow,
    TableFooter
} from '@ui';
import { FormattedDate, FormattedMessage } from 'react-intl';

export const AmotisationPhaseHeader = () => {
    return (
        <div className="space-y-xs rounded-t-m bg-secondary-95 p-l">
            <h3 className="my-0">
                <FormattedMessage
                    id="_.rcf_approved_view.repayment_phase_heading"
                    defaultMessage="Amortisation phase"
                />
            </h3>
            <Text>
                <FormattedMessage
                    id="_.rcf_approved_view.repayment_phase_description"
                    defaultMessage="If you do not extend your repayment-free period, the outstanding loan amount will be repaid in 12 monthly instalments as scheduled."
                />
            </Text>
        </div>
    );
};

export const AmortisationPhaseTable = ({
    schedule,
    summary
}: {
    schedule: GetDrawDownRepaymentScheduleCreditFacilityResponse['data']['schedule'];
    summary: GetDrawDownRepaymentScheduleCreditFacilityResponse['data']['summary'];
}) => {
    const totalPrincipal = summary.total_credit_amount!;
    const totalInterest = summary.total_interest!;
    const totalPayable = summary.total_payable!;

    return (
        <div className="rounded-b-l bg-secondary-95">
            <Table
                className="border-separate border-structure-80"
                title="Repayment phase table"
            >
                <TableHeader className="bg-secondary-95">
                    <TableRow>
                        <TableHead>
                            <FormattedMessage
                                id="_.rcf_approved_view.repayment_schedule_table_date"
                                defaultMessage="Date"
                            />
                        </TableHead>
                        <TableHead>
                            <FormattedMessage
                                id="_.rcf_approved_view.repayment_schedule_table_principal"
                                defaultMessage="Principal"
                            />
                        </TableHead>
                        <TableHead>
                            <FormattedMessage
                                id="_.rcf_approved_view.repayment_schedule_table_interest"
                                defaultMessage="Interest"
                            />
                        </TableHead>
                        <TableHead>
                            <FormattedMessage
                                id="_.rcf_approved_view.repayment_schedule_table_total"
                                defaultMessage="Total Repayment"
                            />
                        </TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {schedule.map((repayment, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <FormattedDate value={repayment.date} />
                            </TableCell>
                            <TableCell>
                                <FormattedCurrency
                                    value={repayment.principal}
                                />
                            </TableCell>
                            <TableCell>
                                <FormattedCurrency value={repayment.interest} />
                            </TableCell>
                            <TableCell>
                                <FormattedCurrency value={repayment.total} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TableCell>
                            <FormattedMessage
                                id="_.rcf_approved_view.repayment_scedule_table_footer_total"
                                defaultMessage="Total"
                            />
                        </TableCell>
                        <TableCell>
                            <FormattedCurrency value={totalPrincipal} />
                        </TableCell>
                        <TableCell>
                            <FormattedCurrency value={totalInterest} />
                        </TableCell>
                        <TableCell>
                            <FormattedCurrency value={totalPayable} />
                        </TableCell>
                    </TableRow>
                </TableFooter>
            </Table>
        </div>
    );
};
